<template>
  <SfListItem
    :cornered="cornered"
    :item-id="itemId"
    :item-variant="itemVariant"
    font-weight="medium"
    :background="background"
    @item-click="expanded = !expanded"
  >
    <template #icon>
      <i
        class="icon"
        :class="expanded ? 'icon-chevron-down' : 'icon-chevron-right'"
      />
    </template>
    <template #default>
      {{ header }}
    </template>
    <template #right-content>
      <template v-if="!expanded">
        <slot name="right-content" />
      </template>
    </template>
  </SfListItem>
  <div
    v-if="expanded"
    class="
      tw-border-sf-neutral-light-1
      tw-border-s
      tw-border-y-0
      tw-border-e-0
      tw-border-solid
      tw-ps-1
      tw-ms-3
    "
  >
    <slot />
  </div>
</template>

<script setup lang="ts">
import SfListItem from '@app/shared/vue/components/sf-list/sf-list-item.vue'
import { ref } from 'vue'
import {
  itemVariant,
  ItemVariants,
} from '@app/shared/vue/components/sf-list/constants'

interface Props {
  header: string
  itemId: string
  background: 'default' | 'transparent'
  variant?: ItemVariants
  cornered?: boolean
  initiallyExpanded: boolean
}

const props = withDefaults(defineProps<Props>(), {
  variant: itemVariant.tall,
})

const expanded = ref(props.initiallyExpanded)
</script>
